/**
 * MUAA Admin brand tokens + cell helpers — ported verbatim from the delivered
 * design (`_design/ui_kits/admin/app.jsx`). These are the authoritative values;
 * never introduce off-palette colors or non-system fonts.
 */
export const brand = {
  navy900: '#06122b',
  navy800: '#0a1c40',
  navy700: '#102a55',
  navy: '#0b1b3a',
  gold: '#c49731',
  gold3: '#e6c14e',
  gold4: '#d8ab3c',
  jaguar: '#1e4e8c',
  paper: '#f4f6fa',
  ink: '#1d2535',
  sub: '#5a6478',
  line: '#e6e9f0',
  cardLine: '#eceef4',
  fDisplay: "'Cinzel', Georgia, serif",
  fScript: "'Great Vibes', cursive",
  fSans: "'Montserrat', system-ui, sans-serif",
  goldGrad: 'linear-gradient(180deg,#e6c14e,#c49731)',
  navyGrad: 'linear-gradient(180deg,#0a1c40,#06122b)',
} as const;

/**
 * Status-pill colors → [foreground, background]. Extends the design's regex to
 * cover our real DB enum values (mock_complete, succeeded, revoked, hidden…).
 */
export function statusColor(v: unknown): [string, string] {
  const s = String(v).toLowerCase();
  if (/(verified|confirmed|active|published|visible|sent|enabled|funded|admin|succeeded|mock_complete|paid|approved)/.test(s))
    return ['#1f7a4d', '#e3f3ea']; // green
  if (/(pending|waitlist|scheduled|draft|awaiting|monthly|one-time|queued)/.test(s))
    return ['#8a6a1f', '#f6efd9']; // gold
  if (/(flagged|disabled|failed|blocked|revoked|hidden|refunded|suspended|rejected)/.test(s))
    return ['#a4452f', '#f6e4de']; // red
  if (/(staff|event staff|black tie|sabbath)/.test(s)) return ['#25406e', '#e5ecf7']; // jaguar
  return ['#5a6478', '#eef0f5']; // neutral
}

export const money = (n: number | string): string => '$' + Number(n).toLocaleString();

export const initials = (name: string): string =>
  String(name)
    .trim()
    .split(/\s+/)
    .map((w) => w[0] ?? '')
    .slice(0, 2)
    .join('')
    .toUpperCase();
